import React from 'react';
import styles from './DataLinkUrlText.module.less';
var DataLinkUrlText = function (data, fnOnClick) {
    return React.createElement("span", { className: styles['dataLinkUrlText-wrap'], onClick: fnOnClick }, data);
};
export default DataLinkUrlText;
